<template>
  <b-table striped hover :items="parts"
    ><template v-slot:cell(id)="data">
      <!-- `data.value` is the value after formatted by the Formatter -->
      <router-link :to="`/parts/${data.value}`">{{ data.value }}</router-link>
    </template></b-table
  >
</template>

<script>
// import Web3 from 'web3'
import { mapState } from 'vuex'
// import { load_contract } from '../../utils/init'

export default {
  methods: {},
  computed: {
    ...mapState(['contracts', 'accounts'])
  },
  data() {
    return {
      parts: []
    }
  },
  async mounted() {
    const { contracts, accounts } = this

    // const contracts = await load_contract()
    let count = await contracts.Proxy.methods
      .part_counter()
      .call({ from: accounts })

    if (!count) return

    for (var i = 0; i < count; i++) {
      var part = await contracts.Proxy.methods.parts(i).call({ from: accounts })

      if (!part) return

      const { mfgTimeStamp, cost, partNumber, serialNumber } = part

      const dat = new Date(mfgTimeStamp * 1000)

      let formatted_date =
        dat.getMonth() +
        1 +
        '-' +
        dat.getDate() +
        '-' +
        dat.getFullYear() +
        ' ' +
        dat.getHours() +
        ':' +
        dat.getMinutes() +
        ':' +
        dat.getSeconds()

      this.parts.push({
        id: i,
        cost,
        partNumber,
        serialNumber,
        Date: formatted_date
      })
    }
  }
}
</script>

<style>
* {
}
</style>
